import {
    DELETE_INDICATOR,
    DELETE_INDICATOR_FAIL, FETCH_INDICATOR, LOAD_INDICATOR,
    PATCH_INDICATOR, PATCH_INDICATOR_FAIL,
    POST_INDICATOR,
    POST_INDICATOR_FAIL
} from "./actionTypes";

const initialState = {
    id: 0,
    title: "",
    comment:"",
    target: 0,
    advancement: 0,
    advancementType: "",
    pilot: {},
    ObjectivePilot: {},
    ObjectiveTitle:'',
    ObjectiveId: 0,
    onGoing: true,
    endDate: "",
    lastUpdate: "",
    message: "",
    status: 0,
    isLoading: false
}

const indicatorReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_INDICATOR:
            return {
                ...state,
                isLoading: true
            }

        case FETCH_INDICATOR:
            return {
                id: action.payload.id,
                title: action.payload.title,
                comment: action.payload.comment,
                target: action.payload.target,
                advancement: action.payload.advancement,
                advancementType: action.payload.advancementType,
                pilot: action.payload.pilot,
                endDate: action.payload.endDate,
                lastUpdate: action.payload.lastUpdate,
                onGoing: action.payload.onGoing,
                ObjectivePilot: action.payload.OKRPilot,
                ObjectiveId: action.payload.OKRId,
                ObjectiveTitle: action.payload.OKRTitle,
                message: action.payload.message,
                status: action.payload.status,
                isLoading: false
            }
        case POST_INDICATOR :
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status,
            }
        case POST_INDICATOR_FAIL || PATCH_INDICATOR || PATCH_INDICATOR_FAIL:
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status,
            }
        case DELETE_INDICATOR || DELETE_INDICATOR_FAIL:
            return {
                ...state,
                message: action.payload.message,
                status: action.payload.status,
            }
        default:
            return {
                ...state
            }

    }
}

export default indicatorReducer;